<template>
  <div class="pageNotFound">
    <div class="left-bg">
      <div class="botui-app-container" id="pageNotFoundBot">
        <bot-ui></bot-ui>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'pageNotFound',
  };
</script>

<style type="text/css">
  .pageNotFound {
    height: 100vh;
    width: 100vw;
    background: #2c3e50;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #3498db, #2c3e50);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #3498db, #2c3e50); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
  .pageNotFound .left-bg {
    background-size: cover;
    display: block;
    position: relative;
    width: 320px;
    height: 610px;
    margin: 0 auto;
    text-align: center;
  }
  #pageNotFoundBot {
    width: 280px;
    top: 50px;
    position: absolute;
  }
  @media screen and (max-width: 1000px) {
    #pageNotFoundBot .botui-container {
      height: 350px;
    }
  }
  #pageNotFoundBot .botui-container {
    background-color: transparent;
  }
  #pageNotFoundBot .botui-container::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
  #pageNotFoundBot .botui-actions-container {
    text-align: right;
  }
  .botui-message {
    text-align: left;
  }
  #mpageNotFoundBot .botui-actions-buttons-button {
    box-shadow: none;
    border-radius: 25px;
  }
  .botui-actions-buttons-button:focus {
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// PageNotFound.vue?622ba434